import React from 'react';
import PropTypes from 'prop-types';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';
import PlaceholderField from 'components/HealthRecords/Documents/DocumentTemplate/Utils/PlaceholderField';
import { isEditableBy } from '../SelectedElementEditPanel/EditableByRolesEnum';

const DocumentTemplateCheckbox = (props) => {
  let {
    field,
    selectedEditElement,
    editMode,
    prefill,
    fieldValues,
    pageWidth,
    pageHeight,
    selectEditElement,
    handleStop,
    onChange,
    updateField,
    toggleQuickPlaceholder,
    role,
  } = props;

  const {
    x_percent,
    y_percent,
    id,
    placeholder,
    scale = 1.0,
    circle = false,
    circle_scale = 1.0,
  } = field;

  let value = undefined;

  let isEditable = editMode || isEditableBy(field?.editable_by, role);

  if (fieldValues[id] !== undefined) value = fieldValues[id] === true || fieldValues[id] === 'on';
  else if (placeholder && prefill && prefill[placeholder] !== undefined)
    value = prefill[placeholder] === true;

  //WARNING: this may be brittle. the "value" field is being used because
  //outerHTML does not give us the "checked" value

  if (editMode) value = true;

  let selected = selectedEditElement === id;

  let outerStyle = {
    position: 'absolute',
    left: x_percent,
    top: y_percent,
    width: '12px',
    height: '12px',
  };

  let checked = value || false;

  let style = DocumentTemplateUtils.parseStyle(field.style || {}) || {};

  style = {
    margin: 0,
    padding: 0,
    position: 'absolute',
    cursor: 'pointer',
    ...(style || {}),
    transform: scale ? 'scale(' + scale + ')' : undefined,
    appearance: checked ? undefined : 'none',
  };

  if (!checked) style.opacity = '0.15';

  const isSelected = selectedEditElement === id;

  let wrapperClassName = 'input-wrapper';
  if (isEditable) wrapperClassName += ' editable';
  if (isSelected) wrapperClassName += ' edit';

  let circleStyle = {};

  if (circle) {
    let scaleX = scale;
    let scaleY = scale * circle_scale;
    circleStyle = {
      width: '12px',
      height: '12px',
      border: checked ? '1px solid black' : 'none',
      borderRadius: '50%',
      transform: scale ? `scale(${scaleX}, ${scaleY})` : undefined,
      position: 'absolute',
      zIndex: 0,
    };

    style.zIndex = 1;

    if (scale) style.transform = `scale(${scaleX}, ${scaleY})`;

    if (checked) {
      style.opacity = '0';
    }
  }

  const inputClassName = `template-field ${selected ? 'edit' : ''}`;

  let checkbox = (
    <div className={wrapperClassName}>
      {isSelected && toggleQuickPlaceholder && (
        <div className="top-options">
          <PlaceholderField updateField={updateField} element={field} disabled={!isEditable} />
        </div>
      )}
      <div style={outerStyle} key={id}>
        <input
          value={value ? 'checked' : undefined}
          data-field-id={id}
          key={id + value}
          className={inputClassName}
          name={id}
          checked={checked}
          onChange={(event) => {
            if (value) {
              event.target.value = 'off';
            } else {
              event.target.value = 'on';
            }
            onChange(event);
          }}
          type="checkbox"
          style={style}
          disabled={!isEditable}
        />
        {circle && <div style={circleStyle} />}
      </div>
    </div>
  );

  return DocumentTemplateUtils.getRndElement(
    id,
    checkbox,
    {
      x: DocumentTemplateUtils.percentToPixel(x_percent, pageWidth),
      y: DocumentTemplateUtils.percentToPixel(y_percent, pageHeight),
    },
    editMode,
    selectEditElement,
    handleStop,
    undefined,
    { zIndex: isSelected ? 1 : 0 },
  );
};

DocumentTemplateCheckbox.propTypes = {
  field: PropTypes.object,
  selectedEditElement: PropTypes.string,
  editMode: PropTypes.bool,
  prefill: PropTypes.object,
  fieldValues: PropTypes.object,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  selectEditElement: PropTypes.func,
  handleStop: PropTypes.func,
  onChange: PropTypes.func,
};

export default DocumentTemplateCheckbox;
